var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard_container"},[_c('Navbar'),_c('div',{staticClass:"dashboard_content"},[_c('MyCourses')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }